import { connect } from 'react-redux';
import { entitySelectors } from '@store/entity/selectors';
import { guestSelectors } from '@store/guest/selectors';

import { AddAnother } from './AddAnother';

const mapStateToProps = (state) => ({
  property: entitySelectors.getProperty(state),
  userHasAccessToFacilities: guestSelectors.userHasAccessToSpaEntity(state, 'facilities'),
  userHasAccessToSpaClasses: guestSelectors.userHasAccessToSpaEntity(state, 'classes'),
});

export const AddAnotherContainer = connect(mapStateToProps)(AddAnother);
